import React  from 'react';
import PercentageComponentProto from './percentage-proto.jsx';


export default function renderPercentageInView(id, props) {
    return <PercentageComponentProto renderMode="view" id={id} {...props} />;
}